export const formatTextWithParams = (text: string, params: (string | number)[] ) => {
    let formattedText = text;
    params.forEach((param, index) => {
        if (param !== null && param !== undefined) {
            formattedText = formattedText.replace(`%{${index}}`, param.toString());
        }
    });
    return formattedText;
};